"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TranslationProvider = _interopRequireDefault(require("../../TranslationProvider"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var _default = _TranslationProvider.default;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/TranslationProvider/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSGVhZGVyL1RyYW5zbGF0aW9uUHJvdmlkZXIvaW5kZXgudHN4Il0sIm5hbWVzIjpbIlByb3ZpZGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7ZUFJZUEsNEIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvdmlkZXIsIHsgVHJhbnNsYXRpb25Qcm92aWRlciB9IGZyb20gJy4uLy4uL1RyYW5zbGF0aW9uUHJvdmlkZXInO1xuXG5leHBvcnQgdHlwZSBUcmFuc2xhdGlvbnMgPSAnb3Blbl9tZW51JyB8ICdjbG9zZV9tZW51JyB8ICdob21lJyB8ICduZXdfZmVhdHVyZSc7XG5cbmV4cG9ydCBkZWZhdWx0IFByb3ZpZGVyIGFzIFRyYW5zbGF0aW9uUHJvdmlkZXI8VHJhbnNsYXRpb25zPjtcbiJdfQ==